<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3" v-if="animationFields && animationFields.length">
        <input
          class="check form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">Animations </h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer" @click="addNewAnimation()">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
          />
        </span>
        <span
          v-if="isSelected"
          class="cursor-pointer ml-3"
          @click="deleteAllAnimations()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div class="mb-3">
      <div v-for="(item, index) in animationFields" :key="index">
        <div class="fields-wrapper is-divider is-multi-node mb-3">
          <div class="form-check select-single">
            <input
              class="form-check-input"
              type="checkbox"
              @change="checkSingleSelect"
              v-model="item.animation.selectSingle"
            />
          </div>
          <div
            class="action-buttons"
          >
            <span
              class="action-item "
              @click="copyAnimation(index, item)"
            >
              <i class="fa fa-copy"></i>
            </span>
            <span
              v-if="item.animation.selectSingle"
              class="action-item"
              @click="deleteAnimation(index)"
            >
              <i class="fa fa-trash"></i>
            </span>
          </div>
          <div>
            <div class="row">
              <div class="col-6">
                <div class="row form-group align-items-center">
                  <label for="animation_selector" class="col-sm-5 col-form-label">
                    Animation Selector
                  </label>
                  <div class="col-sm-7">
                    <select id="animation_selector"
                      v-model="item.animation.animationId"
                      @change="changeSelectedAnimation(index, item)"
                      class="custom-select"
                    >
                      <option  v-for="(animation, index) in assetAnimations"
                        :key="index"
                        class="custom-select"
                        :value="index"
                      >
                      {{animation.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Start Time (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      :id="index"
                      v-model="item.animation.startTime"
                      :min="index !== 0
                          ? parseInt(animationFields[index - 1].animation.startTime)
                          : 0
                        "
                      @change="checkStartTime"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    End Time (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="number"
                      :id="index"
                      v-model="item.animation.endTime"
                      class="form-control"
                      @change="checkEndTime"
                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Animation Duration (sec)
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      class="form-control"
                      :value="((item.animation.endTime  - item.animation.startTime) * item.animation.loopCount).toFixed(2) || 0"
                      readonly
                    />
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Number of Loops
                  </label>
                  <div class="col-sm-7">
                    <input
                      class="form-control"
                      type="number"
                      min="1"
                      v-model="item.animation.loopCount"
                      @change="setDuration(index)"
                    >
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label for="rig" class="col-sm-5 col-form-label">
                    Rig
                  </label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="animname" v-model="item.animation.rig" readonly>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label for="inverse_kinematics" class="col-sm-5 col-form-label">
                    Inverse Kinematics
                  </label>
                  <div class="col-sm-7">
                    <select id="inverse_kinematics" class="custom-select" v-model="item.animation.inverseKinematics">
                      <option>Link 1</option>
                      <option>Link 2</option>
                      <option>Link 3</option>
                    </select>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Trim
                  </label>
                  <div class="col-sm-7">
                    <input type="range" min="1" max="100" v-model="item.animation.trim">
                    <span class="ml-2">{{ item.animation.trim }}</span>
                  </div>
                </div>
              </div>
              <div class="col-6 align-items-center">
                <div class="row form-group mb-4">
                  <label class="col-sm-5 col-form-label">
                    Test Animation
                  </label>
                  <div class="col-sm-7">
                    <button
                      v-if="isPreviewPaused || !isPreviewStarted"
                      @click="startPreview(index)"
                      class="btn btn-outline-success"
                      id="select_audio_duration_s"
                    >
                      <i class="fa fa-play"></i>
                    </button>
                    <button
                      v-if="isPreviewStarted && !isPreviewPaused"
                      @click="pausePreview(index)"
                      class="btn btn-outline-warning" id="select_audio_duration_pause">
                      <i class="fa fa-pause"></i>
                    </button>
                    <button
                      @click="stopPreview(index)"
                      class="btn btn-outline-danger" id="select_audio_duration_stop">
                      <i class="fa fa-stop"></i>
                    </button>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label for="no_of_joints" class="col-sm-5 col-form-label">
                    Joints Count
                  </label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control" id="no_of_joints" v-model="item.animation.jointsCount" readonly>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Destination Postion
                  </label>
                  <div class="col-sm-7">
                    <div class="d-flex align-items-center">
                      <span class="p-2">x</span>
                      <input type="text" class="form-control" id="destination_position_x" v-model="item.animation.destination.position[0]">
                      <span class="p-2">y</span>
                      <input type="text" class="form-control" id="destination_position_y" v-model="item.animation.destination.position[1]">
                      <span class="p-2">z</span>
                      <input type="text" class="form-control" id="destination_position_z" v-model="item.animation.destination.position[2]">
                    </div>
                  </div>
                </div>
                <div class="row form-group align-items-center">
                  <label class="col-sm-5 col-form-label">
                    Destination Rotation
                  </label>
                  <div class="col-sm-7">
                    <div class="d-flex align-items-center">
                      <span class="p-2">x</span>
                      <input type="text" class="form-control" id="destination_position_x" v-model="item.animation.destination.rotation[0]">
                      <span class="p-2">y</span>
                      <input type="text" class="form-control" id="destination_position_y" v-model="item.animation.destination.rotation[1]">
                      <span class="p-2">z</span>
                      <input type="text" class="form-control" id="destination_position_z" v-model="item.animation.destination.rotation[2]">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fields-wrapper is-multi-node" v-if="hasNext(index)">
          <div class="row">
          <div class="col-6">
            <h4>Stitch</h4>
            <div class="row form-group align-items-center">
              <label for="stitch" class="col-sm-5 col-form-label">
                Stitch Selector
              </label>
              <div class="col-sm-7">
                <select id="stitch" class="custom-select" v-model="item.animation.stitch">
                  <option value="Reaction">Reaction</option>
                  <option value="Burpee">Burpee</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <h4>Blend</h4>
            <div class="row form-group align-items-center">
              <label for="blend" class="col-sm-5 col-form-label">
                Blend Selector
              </label>
              <div class="col-sm-7">
                <select id="blend" class="custom-select" v-model="item.animation.blend">
                  <option value="Reaction">Reaction</option>
                  <option value="Burpee">Burpee</option>
                </select>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../../../../../firebaseDB'
import {uuid} from 'vue-uuid'
import { mapActions, mapState, mapGetters } from 'vuex'
import { defaultRotation } from '../../../../../../external_libs/frame.js/editor/js/libs/util'
import { DraggingTool } from 'gojs'

export default {
  components: {},
  data () {
    return {
      hasAnimation: false,
      animationFields: [],
      selectAll: false,
      isSelected:false,
      range_slider: 0,
      trim_slider: 0,
      activeButton: 'Select Animation',
      isPreviewStarted: false,
      isPreviewPaused: false,
      objectId: '',
      activeModel: {},
    }
  },
  beforeDestroy () {
    this.$root.$off('addAnimation')
  },
  created () {
    this.listAssetAnimations()
    this.$root.$on('addAnimation', () => {
      this.addNewAnimation()
    })
  },

  methods: {
    ...mapActions(['listAssetAnimations']),
    addNewAnimation () {
      // const index = this.animationFields.length ? this.animationFields.length - 1 : 0;
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      duration = duration <= 5 ? duration : 5;
      let start = 0
      let end = 0
      if (duration >= 2) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(duration)).toFixed(2)
        duration = parseFloat(duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + 5).toFixed(2) : parseFloat(this.activeModel.startTime) + 5
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = 5
      }

      const firstAssetIndex = Object.keys(this.assetAnimations)[0]
      this.animationFields.push({
        elementType: 'Animation',
        id: uuid.v1(),
        animation: {
          animationId: firstAssetIndex,
          destination: {
            position: [
                0,
                0,
                0
            ],
            rotation: [
                0,
                0,
                0
            ]
          },
          AndroidAssetBundle: this.assetAnimations[firstAssetIndex].asset_bundle.Android.fileURL,
          iOSAssetBundle: this.assetAnimations[firstAssetIndex].asset_bundle.iOS.fileURL,
          webglAssetBundle: this.assetAnimations[firstAssetIndex].asset_bundle.WebGL.fileURL,
          loopCount: 1,
          name: this.assetAnimations[firstAssetIndex].name,
          endTime: end,
          startTime: start,
          duration: duration,
          trim: 0,
          blend: '',
          stitch: '',
          jointsCount: 0,
          inverseKinematics: '',
          rig: this.assetAnimations[firstAssetIndex].rig ? this.assetAnimations[firstAssetIndex].rig : ''
        }
      })
      this.reflext()
    },
    reflext () {
      let newChar =
        this.characters &&
        this.characters.map(char =>
          char.objectId === this.objectId
            ? {
              ...char,
              object3DElements: 
              char.object3DElements ? [
                ...char.object3DElements.filter(
                  el => !el.hasOwnProperty('animation')
                ),
                ...this.animationFields
              ] :  
              [ ...this.animationFields ]
            }
            : {...char}
        )
      this.$store.dispatch('updateCharacters', newChar)
    },
    nextElement (time) {
      let duration = 5
      let min = 99999999
      let element = this.animationFields.filter((el) => {
        return (parseFloat(el.animation.startTime) <= time && parseFloat(el.animation.startTime) + parseFloat(el.animation.duration) > time)
      })
      if (element.length) {
        return 0;
      }
      element = this.animationFields.forEach((el) => {
        if (parseFloat(el.animation.startTime) >= time && parseFloat(el.animation.startTime) <= min) {
          duration = parseFloat(el.animation.startTime) - time
          min = parseFloat(el.animation.startTime)
        }
      })
      return duration;
    },
    checkSingleSelect () {
      this.animationFields.forEach(value => {
        if (value.animation.selectSingle) {
          this.isSelected = true
        }
      })
    },
    deleteAnimation (index) {
      let id = this.animationFields[index].id
      if (index > -1) {
        this.animationFields.splice(index, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', id, 'Animation', this.activeModel.objectId)
    },
    copyAnimation (index, item) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (duration >= item.animation.duration) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(item.animation.duration)).toFixed(2)
        duration = parseFloat(item.animation.duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + 5).toFixed(2) : parseFloat(this.activeModel.startTime) + parseFloat(item.animation.duration)
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeModel.startTime)
        duration = parseFloat(item.animation.duration)
      }


      this.animationFields[index].animation.isCopied = !this.animationFields[index]
        .animation.isCopied
      let lastIndex = this.animationFields.length - 1;
      this.animationFields.push({
        elementType: 'Animation',
        id: uuid.v1(),
        animation: {
          animationId: item.animation.animationId,
          destination: item.animation.destination,
          AndroidAssetBundle: item.animation.AndroidAssetBundle,
          iOSAssetBundle: item.animation.iOSAssetBundle,
          webglAssetBundle: item.animation.webglAssetBundle,
          loopCount: item.animation.loopCount,
          name: item.animation.name,
          endTime: end,
          startTime: start,
          duration: duration,
          trim: item.animation.trim,
          blend: item.animation.blend,
          stitch: item.animation.stitch,
          jointsCount: item.animation.jointsCount,
          inverseKinematics: item.animation.inverseKinematics,
        }
      })
      this.reflext()
    },
    deleteAllAnimations () {
      this.animationFields = []
      let newChar =
        this.characters &&
        this.characters.map(char => {
            if (char.objectId === this.objectId) {
              let object3DElements = char.object3DElements.filter(value => {
                return !value.animation
              })
              return { ...char, object3DElements: object3DElements }
            } else {
              return { ...char }
            }
        })
      this.$store.dispatch('updateCharacters', newChar)
      this.selectAll = false
    },
    changeSelectedAnimation (index, item) {
      let selectedAnimation = this.assetAnimations[item.animation.animationId];
      this.updateAnimationData(index, selectedAnimation);
      this.$emit('selectedAnimation', {'selectedAnimation': index})
    },
    updateAnimationData (index, selectedAnimation) {
      this.animationFields[index].animation.name  = selectedAnimation.name;
      this.animationFields[index].animation.rig = selectedAnimation.rig ? selectedAnimation.rig : 0;
      this.animationFields[index].animation.jointsCount = selectedAnimation.jointsCount ? selectedAnimation.jointsCount : 0;
      this.animationFields[index].animation.AndroidAssetBundle = selectedAnimation.asset_bundle.Android.fileURL;
      this.animationFields[index].animation.iOSAssetBundle = selectedAnimation.asset_bundle.iOS.fileURL;
      this.animationFields[index].animation.webglAssetBundle = selectedAnimation.asset_bundle.WebGL.fileURL;
    },
    hasNext (index) {
      return this.animationFields.length > index + 1;
    },
    getDuration(index) {

      return  this.animationFields[index].animation.endTime && this.animationFields[index].animation.startTime ? 
      (parseInt(this.animationFields[index].animation.endTime) - parseInt(this.animationFields[index].animation.startTime)
        ) * parseInt(this.animationFields[index].animation.loopCount) : '';
    },
    checkStartTime (event) {
      let index = parseInt(event.target.id)
      if (
        index !== 0 &&
        (parseFloat(this.animationFields[index].animation.startTime) <
          parseFloat(this.animationFields[index - 1].animation.startTime) + parseFloat(this.animationFields[index - 1].animation.duration))
      ) {
        this.animationFields[index].animation.startTime =
          parseFloat(parseFloat(this.animationFields[index - 1].animation.startTime) +
           (parseFloat(this.animationFields[index - 1].animation.endTime) - parseFloat(this.animationFields[index - 1].animation.startTime)) * parseFloat(this.animationFields[index - 1].animation.loopCount)
        )
      }
      if (parseFloat(this.animationFields[index].animation.startTime) >
          parseFloat(this.animationFields[index].animation.endTime)
      ) {
        this.animationFields[index].animation.endTime =
          parseFloat(parseFloat(this.animationFields[index].animation.startTime) + 1
        )
      }
      this.setDuration(index)
    },
    checkEndTime (event) {
      let index = parseInt(event.target.id)
      if (parseFloat(this.animationFields[index].animation.startTime) >
          parseFloat(this.animationFields[index].animation.endTime)
      ) {
        this.animationFields[index].animation.endTime =
          parseFloat(parseFloat(this.animationFields[index].animation.startTime) + 1
        )
      }
      this.setDuration(index)
    },
    setDuration (index) {
       this.animationFields[index].animation.duration = (
         this.animationFields[index].animation.endTime - this.animationFields[index].animation.startTime
         ) * parseInt(
           this.animationFields[index].animation.loopCount
        )
    },
    saveToDB () {
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
      tRef.once('value').then(async snapshot => {
        let json = snapshot.val().json
        let storyData = snapshot.val();
        let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
        .filter(n => n.key !== 'Start')
        .filter(n => n.category == 'Scene');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
        let object3DElements = []
        for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
          if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty('character') && json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.objectId == this.objectId) {
            for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.object3DElements) {
              if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.object3DElements[innerKey].elementType === 'Animation') {
                delete json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.object3DElements[innerKey]
              } else {
                object3DElements.push(json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.object3DElements[innerKey])
              }
            }
            const data = []
            _this.animationFields.forEach((value, key) => {
              object3DElements.push({
                elementType: value.elementType,
                animation: {...value.animation},
                id: value.id
              })
            })
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.object3DElements = object3DElements
            let updates = {}
            updates[localStorage.getItem('storyId') + `/json`] = json
            db.ref('stories')
              .update(updates)
              .then(snapshot => {
                _this.showSuccessToast()
                if(!_this.animationFields.length) {
                  _this.addNewAnimation()
                }
              })
              .catch(e => {
                _this.showErrorToast()
              })
            this.$parent.activeComponent = 'animations'
          }
        }
      })
    },
    showSuccessToast () {
      this.$toast('Animation inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Animation inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    pausePreview (index) {
      this.isPreviewPaused = true;
      // add preview code
    },
    stopPreview (index) {
      this.isPreviewStarted = false;
      this.isPreviewPaused = false;
      // add preview code
    },
    startPreview (index) {
      this.isPreviewStarted  = true;
      // add preview code
    },
    changeSelectedObject () {
      this.animationFields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.objectId =  val.objectId
          this.activeModel = val
          if (val.object3DElements) {
            val.object3DElements.forEach(element => {
              if (element.elementType === 'Animation') {
                this.animationFields.push(element)
              }
            });
          }
        }
      })
    }
  },
  mounted () {
    this.animationFields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.objectId =  val.objectId
          this.activeModel = val
          if (val.object3DElements) {
            val.object3DElements.forEach(element => {
              if (element.elementType === 'Animation') {
                this.animationFields.push(element)
              }
            });
          }
        }
      })
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.animationFields) {
        this.animationFields.forEach(value => {
          value.animation.selectSingle = val
        })
      }
    },
    characters (val) {
      this.changeSelectedObject();
    },
  },
  computed: {
    lastElementEndTime () {
      let max = 0
      this.animationFields.forEach((el) => {
        if (parseFloat(el.animation.startTime) + parseFloat(el.animation.duration)  >= max) {
          max = parseFloat(el.animation.startTime) + parseFloat(el.animation.duration) 
        }
      })
      return max;
    },
    ...mapState([
      'assetAnimations',
      'characters',
      'timeLineCursor'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/models/animations.vue